import { Assessment } from "interfaces/assessment";
import { Evaluation } from "interfaces/evaluation";

const findLastMetricInAssessmentsByTag = (assessments: Assessment[], tag: string) : string | null => {
    if(!assessments || assessments.length == 0) return null;
    
    const arrangedAssessments = [...assessments];

    const sortedAssessments = arrangedAssessments.sort(
        (a, b) => new Date(b.answered_at).getTime() - new Date(a.answered_at).getTime()
    );

    for (const assessment of sortedAssessments) {
        const metric = assessment.metrics.find(m => m.tag === tag);
        if (metric) {
            const result = metric.result
            return result;
        }
    }

    return null;
}

const findLastEvaluationInAssessmentsByTag = (assessments: Assessment[], tag: string) : Evaluation | null => {
    if(!assessments || assessments.length == 0) return null;
    
    const arrangedAssessments = [...assessments];

    const sortedAssessments = arrangedAssessments.sort(
        (a, b) => new Date(b.answered_at).getTime() - new Date(a.answered_at).getTime()
    );

    for (const assessment of sortedAssessments) {
        const evaluations = assessment.evaluations;
        const evaluation = evaluations.find(m => m.tag === tag);
        if (evaluation) {
            const result = evaluation
            return result;
        }
    }

    return null;
}

export {
    findLastMetricInAssessmentsByTag,
    findLastEvaluationInAssessmentsByTag
}